<template>
  <div class="orcamento-liberados">
    <g-card
      class="card-orcamento-liberados"
      margem="20px"
      ref="cardDeBusca"
      :expansivel="true"
      :comecaFechado="false"
    >
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Orçamentos Liberados </div>
          <div class="header-icons">
            <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              v-on:acao="clear"
            />
            <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="15px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              v-on:acao="buscar"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="conteudo-orcamento-liberado espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros">Unidade</div>
            <PDropDown
            class="unidade-input input-label"
            placeholder="TODAS"
            :filter="true"
            :options="EmpresaArray"
            optionLabel="nome"
            optionValue="id"
            v-model="formSearch.UnidadeId"
            ></PDropDown>
          </div>

          <div class="cliente">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <!-- <PDropDown
              v-model="formSearch.ClienteId"
              :filter="true"
              @filter="getClientes($event.value)"
              :options="dataClientes"
              optionLabel="nomeFantasia"
              optionValue="id"
              placeholder="Selecione o Cliente"
              class="input-multiselect"
            >
              <template #option="slotProps">
                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
              </template>
            </PDropDown> -->
            <cliente-dropdown 
              class="cliente-input input-label"
              v-model="formSearch.ClienteId"
              :empresaId="formSearch.UnidadeId"
              :representanteId="this.$store.state.representanteSelecionadoId"
            />
          </div>

          <div class="numero-orcamento">
            <div class="numero-orcamento-titulo titulo-conteudo-filtros"> Nº Solicitação </div>
            <PInputText
            class="numero-orcamento-input input-label"
            placeholder="Insira o número da solicitação"
            v-model="formSearch.NumeroSolicitacao"
            />
          </div>
          
          <div class="produto-ordenacao">
            <div class="produto-ordenacao-titulo titulo-conteudo-filtros"> Produto </div>
            <PDropDown
            class="produto-ordenacao-input input-label"
            placeholder="Selecione o Produto"
            :filter="true"
            @filter="getOrcamentoProdutos($event.value)"
            :options="OrcamentoProdutoArray"
            optionLabel="labelProduto"
            optionValue="produtoId"
            v-model="formSearch.OrcamentoProdutoId"
            >
              <template #option="slotProps">
                <produto-dropdown-item :produto="slotProps.option"></produto-dropdown-item>
              </template>
            </PDropDown>
          </div>

          <div class="linha-producao">
            <div class="linha-producao-titulo titulo-conteudo-filtros"> Linha de Produção </div>
            <PDropDown
              class="linha-producao-input input-label"
              placeholder="Selecione"
              :filter="true"
              :options="LinhaProdutoArray"
              optionLabel="nomeCidade"
              v-on:blur="habilitarbotao"
              v-model="CidadeSelecionada"
            ></PDropDown>
          </div>

          <div class="data-emissao">
            <div class="data-emissao-titulo titulo-conteudo-filtros"> Período de Emissão </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                  class="data-emissao-inicio-input input-label"
                  placeholderinput="Início"
                  :dataPassadas="true"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  retornaDateTime 
                  v-model="formSearch.PeriodoEmissaoInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                  class="data-emissao-termino-input input-label"
                  placeholderinput="Término"
                  :dataPassadas="true"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  v-model="formSearch.PeriodoEmissaoFim"
                ></g-date-input>
              </div>
            </div>
          </div>

          <div class="data-baixa">
            <div class="data-baixa-titulo titulo-conteudo-filtros"> Período de Baixa </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                  class="data-baixa-inicio-input input-label"
                  placeholderinput="Início"
                  :dataPassadas="true"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  invertido
                  retornaDateTime 
                  v-model="formSearch.PeriodoBaixaInicio"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                  class="data-baixa-termino-input input-label"
                  :dataPassadas="true"
                  placeholderinput="Término"
                  alturainput="45px"
                  largurainput="100%"
                  tamanhobotao="35px"
                  v-model="formSearch.PeriodoBaixaFim"
                ></g-date-input>
              </div>
            </div>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="15px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        @click="buscar()"
        >
        BUSCAR
        </g-button>
      </div>
    </g-card>

    <g-card
      class="card-resultado"
      :expansivel="false"
      :temCabecalho="false"
      paddingDefault="1em 0 3em"
      margem="20px" 
    >
      <div class="" v-if="mensagemvazio">
        <img
          class="icone-global-imagemfundo"
          src="@/assets/imgs/Ilustracao_erro.svg"
        />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e click em buscar para exibir os resultados
        </div>
      </div>

      <div v-else-if="!mensagemvazio">
        <g-data-table
          TextoVazio="Nenhum Orçamento Encontrado"
          Titulo="Orçamentos Liberados"
          :colunas="Colunas"
          :Paginacao="true"
          :valores="OrcamentoArray"
          :NumeroLinhas="100"
          :Filtros="Filtro"
          :FiltrosEspecificos="true"
          :Editavel="false"
          :Imprimivel="false"
          :rowEditor="true"
          EscondeColunaBotao
          v-on:duploClickLinha="abrePopup"
          :campoAgrupador="'empresaCliente'"
          :campoExibicaoGrupo="'empresaCliente'"
          altura="auto"
        ></g-data-table>
      </div>

      <PDialog
      :showHeader="false"
      :closable="false"
      v-model:visible="popup"
      :modal="true"
      >
        <div class="titulo-popup"> Deseja criar um novo Orçamento com as mesmas informações? </div>
        <div class="botoes-popup">
          <div class="botao-sim">
            <g-button
            tipo="cinza"
            negritoTexto
            altura="35px"
            largura="200px"
              @click="redireciona"
            >
              SIM
            </g-button>
          </div>
          <div class="botao-nao">
            <g-button 
            negritoTexto
            altura="35px"
            largura="200px"
            @click="fechaPopup"
            >
              NÃO
            </g-button>
          </div>
        </div>
      </PDialog>
    </g-card>

    <PDialog :showHeader="false" :closable="false" v-model:visible="gerarCartaPropostaPopup">
      <div class="titulo-popup"> Deseja criar uma Carta Proposta para este orçamento? </div>
      <div class="botoes-popup">
        <div class="botao-sim">
          <g-button
          tipo="cinza"
          negritoTexto
          altura="35px"
          largura="200px"
          @click="gerarCartaPropostaPopup = false"
          >
            NÃO
          </g-button>
        </div>

        <div class="botao-nao">
          <g-button
            negritoTexto
            altura="35px"
            largura="200px"
            @click="criarCartaProposta"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>


  <script>
import OrcamentosLiberados from "./OrcamentosLiberados.js";
export default OrcamentosLiberados;
</script>

<style scoped>

@media (min-width: 310px) {
.conteudo-orcamento-liberado {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, auto);
  grid-column-gap: 20px;
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-orcamento { grid-area: 2 / 1 / 3 / 2; }
.produto-ordenacao { grid-area: 2 / 2 / 3 / 3; }
.linha-producao { grid-area: 3 / 1 / 4 / 2; }
.data-emissao { grid-area: 3 / 2 / 4 / 3; }
.data-baixa { grid-area: 4 / 1 / 5 / 2; }
}

@media (min-width: 368px) {
}

@media (min-width: 600px) {
}

@media (min-width: 801px) {
.conteudo-orcamento-liberado {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-orcamento { grid-area: 1 / 3 / 2 / 4; }
.produto-ordenacao { grid-area: 2 / 1 / 3 / 2; }
.linha-producao { grid-area: 2 / 2 / 3 / 3; }
.data-emissao { grid-area: 2 / 3 / 3 / 4; }
.data-baixa { grid-area: 3 / 1 / 4 / 2; }
}

@media (min-width: 1025px) {

}
@media (min-width: 1281px) {
.conteudo-orcamento-liberado {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, auto);
}

.unidade { grid-area: 1 / 1 / 2 / 2; }
.cliente { grid-area: 1 / 2 / 2 / 3; }
.numero-orcamento { grid-area: 1 / 3 / 2 / 4; }
.produto-ordenacao { grid-area: 1 / 4 / 2 / 5; }
.linha-producao { grid-area: 2 / 1 / 3 / 2; }
.data-emissao { grid-area: 2 / 2 / 3 / 3; }
.data-baixa { grid-area: 2 / 3 / 3 / 4; }
}

@media (min-width: 1500px) {

}
</style>
